import { isCommercialSelector } from 'shared/selectors/offerData/offer/isCommercialSelector';

import { IState } from '../../store';

export const selectIsInfrastructureMicrofrontendEnabled = (state: IState): boolean => {
  const isCommercial = isCommercialSelector(state);

  return !isCommercial;
};
